
import { BusFront, TramFront } from "lucide-react";
import { TransportData } from "./Interfaces/ListingsInterface";

interface TransportSectionProps {
    bus?: TransportData;
    train?: TransportData;
}

export default function TransportSection({
    bus,
    train,
}: TransportSectionProps) {

    return (
        <div>
            {(bus?.name && bus?.travelTimeModeString) || (train?.name && train?.travelTimeModeString) ? (
                <div className='w-full bg-gray-50 p-4 md:p-4 rounded-lg mt-10'>
                    <div className='grid grid-cols-1 sm:grid-cols-2 gap-4 divide-y sm:divide-y-0 sm:divide-x divide-gray-200'>
                        {bus?.name && bus?.travelTimeModeString && (
                            <div className='flex items-center gap-4 py-0 md:py-4 sm:pr-8 w-full sm:w-auto justify-start'>
                                <div className='flex items-center justify-center w-10 h-10'>
                                    <BusFront
                                        size={50}
                                        strokeWidth={1}
                                        className='text-oh-dark-gray' />
                                </div>
                                <div className="flex flex-col">
                                    <p className="text-sm text-oh-gray">
                                        Bus Station
                                    </p>

                                    <p className="text-oh-gray text-base truncate max-w-[300px]">
                                        {bus?.name}
                                    </p>

                                    <p className="font-semibold text-oh-black text-base">
                                        {bus?.travelTimeModeString}
                                    </p>
                                </div>
                            </div>
                        )}
                        {train?.name && train?.travelTimeModeString && (
                            <div className='flex items-center gap-4 py-2 md:py-4 sm:pl-8 w-full sm:w-auto justify-start'>
                                <div className='flex items-center justify-center w-10 h-10'>
                                    <TramFront
                                        size={50}
                                        strokeWidth={1}
                                        className='text-oh-dark-gray' />
                                </div>
                                <div className="flex flex-col">
                                    <p className="text-sm text-oh-gray">
                                        Train Station
                                    </p>

                                    <p className="text-oh-gray text-base truncate max-w-[300px]">
                                        {train?.name}
                                    </p>

                                    <p className="font-semibold text-oh-black text-base">
                                        {train?.travelTimeModeString}
                                    </p>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            ) : null}
        </div>
    );
}
